import React,{useState, useEffect} from "react";
import { useAappContext } from '../context/AppContext'
import { NavLink } from "react-router-dom";

const ProductCategory = ()=>{

    const {onClicktoGet,getProductCategory,productCategory:PCategory, getApiHost,ApiHost} = useAappContext();

    useEffect(()=>{
        getProductCategory()
        getApiHost()
    },[])

   
    return (
        <>

        <section id="pro-category" className="section-p1 section-m1">
            <div className="section-title">
           <div className="title">
           <div className="bar"></div>
            <span>main product Groups</span>
            <div className="bar"></div>
           </div>
            <p>Product groups provided by avansis bangladesh</p>
            </div>
            <div className="categorys">
                    { 
                        PCategory.map((category, index) => { 
                            const {id:alise,name,image} = category;
                                                    
                            return (
                                <NavLink to={'/products/'+name} key={index} > 
                                    <div className="category"  id={alise} onClick={()=>{
                                        
                                        onClicktoGet(alise,name)
                                        
                                        } } >
                                        <div className="category-wrap">
                                        <img width="224px" height="231px" src={ApiHost+image} alt=""/>
                                        <h2>{name}</h2>
                                        </div>
                                    </div>
                                </NavLink>
                            )
                        })
                    }
        </div>
    </section>

        </>
    );
}

export default ProductCategory;


           